export default {
  privat: {
    breadcrumbHome: 'Početna',
    breadcrumbSolutions: 'Rješenja',
    breadcrumbCurrent: 'Dom i okućnica',
    hero: {
      eyebrow: 'Privatni korisnici',
      title: 'Vaš dom pod nadzorom – dobro planiran i diskretno ugrađen',
      lead: 'Obiteljska kuća, stan ili višestambena zgrada: štitimo vašu privatnost i imovinu kamerama po mjeri. Bez zastrašivanja, bez pretjeranog nadzora.',
    },
    useCases: {
      title: 'Rješenja za vaš dom',
      lead: 'Svaka je kuća drugačija. Razmatramo vaše pristupe, uvjete osvjetljenja i želje te planiramo odgovarajuće točke nadzora.',
      items: {
        '0': { title: 'Ulazna vrata i ulaz', desc: 'Ulazna vrata su najvažnija točka nadzora. Planiramo diskretnu kameru s dobrom rezolucijom – za prepoznavanje lica i praćenje paketa.' },
        '1': { title: 'Prilaz i garaža', desc: 'Prepoznavanje registracija, nadzor vozila i kontrola pristupa – otpornim vanjskim kamerama i noćnim vidom.' },
        '2': { title: 'Vrt i terasa', desc: 'Nadzirite vrtne prilaze, terase i sporedne ulaze. Kamere otporne na vremenske uvjete sa širokim kutom za pregled.' },
        '3': { title: 'Sporedni ulazi i podrumska vrata', desc: 'Često zanemareni, ali česta točka pristupa. Dodatne kamere zatvaraju posljednju prazninu.' },
        '4': { title: 'Višestambene zgrade', desc: 'Ulaz, stubište i vanjske površine – planirano s obzirom na privatnost, s maskiranjem i oznakama.' },
        '5': { title: 'Pristup putem pametnog telefona', desc: 'Pregled uživo i reprodukcija na vašem telefonu – kod kuće ili u pokretu. Sve postavljamo.' },
      },
    },
    night: {
      eyebrow: 'Noćni vid',
      title: 'Sigurnost koja ne spava',
      lead: 'Većina incidenata događa se u mraku. Posebnim dan/noć kamerama zadržavate pregled i noću – crno-bijelo infracrveno ili čak u boji.',
      items: {
        '0': { title: 'Infracrveni noćni vid', desc: 'Oštre slike i u potpunom mraku – do 30 m dometa ovisno o modelu.' },
        '1': { title: 'Noćni vid u boji', desc: 'Slike u boji noću umjesto crno-bijelih – zahvaljujući vrlo osjetljivim Starlight senzorima.' },
        '2': { title: 'Inteligentna rasvjeta', desc: 'LED bijela svjetla pri kretanju kao odvraćanje i za snimanje u boji.' },
      },
    },
    privacy: {
      eyebrow: 'Zaštita podataka',
      title: 'Zaštitite privatne zone, poštujte prava',
      lead: 'Kod privatnog videonadzora zaštita podataka je posebno važna. Od početka vodimo računa o:',
      list: {
        '0': 'Bez snimanja javnih cesta ili susjednih parcela',
        '1': 'Maskiranje privatnih zona u kameri ili snimaču',
        '2': 'Oznake na ulazima (zakonski preporučeno)',
        '3': 'Lokalna pohrana – vaši podaci ostaju kod vas',
        '4': 'Prava pristupa i upravljanje korisnicima za zgrade',
      },
      note: 'Napomena: zakonska dopuštenost videonadzora ovisi o pojedinačnom slučaju. Savjetujemo vas, ali ne zamjenjujemo pravni savjet.',
    },
    cta: {
      title: 'Zaštitite ono što vam je važno',
      lead: 'Prvi razgovor bez obveze pokazuje vam mogućnosti za vaš dom – transparentno i bez pritiska.',
      primary: 'Zakažite termin savjetovanja',
      secondary: 'Pokrenite planer kamera',
    },
  },
};